import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { TrackingClient } from "@/features/tracking/TrackingClient";

// Transport → Ritopvolging (Lucien, 22-10-2026; docs/design_handoff_planning_v3/README.md P59): the running trips, read
// with tms_planning; a deviation taken up and a note written with tms_planning_write (Camiel).
export const Route = createFileRoute("/_shell/tracking")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_planning") && !hasModule(context.session, "tms_planning_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: TrackingScreen,
});

function TrackingScreen() {
  const { session } = Route.useRouteContext();
  return (
    <div className="wl-page wl-page--fill" data-screen-label="Back-office Trip Follow-up" style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      <TrackingClient canWrite={hasModule(session, "tms_planning_write")} />
    </div>
  );
}
